import React, { FC } from "react";
import { Table } from "../../organisms/Table";
import { HeaderText, TableWrapper, Wrapper, HeaderWrapper } from "./elements";
import { Button } from "../../atoms/Button";

type Props = {
  tableData: any[];
  columns: any[];
  setRowRecord?: any;
  isLoading?: boolean;
  onCreatePositionClick: () => void;
};

const Positions: FC<Props> = ({
  tableData,
  columns,
  setRowRecord,
  isLoading,
  onCreatePositionClick,
}) => {
  return (
    <Wrapper>
      <HeaderWrapper>
        <HeaderText>Positions</HeaderText>
        <Button type="primary" onClick={onCreatePositionClick}>
          Create Position
        </Button>
      </HeaderWrapper>
      <TableWrapper>
        <Table
          isLoading={isLoading}
          tableData={tableData}
          columns={columns}
          rowRecord={setRowRecord}
        />
      </TableWrapper>
    </Wrapper>
  );
};

export default Positions;
